import { UserRegistrationStatePresenter } from '@/presentation/presenters/userRegistration/userRegistraationStatePresenter'

export function useUserRegistrationStatePresenter(
  presenter: UserRegistrationStatePresenter = new UserRegistrationStatePresenter()
) {
  return {
    id: presenter.id,
    password: presenter.password,
    confirmPassword: presenter.confirmPassword,
    name: presenter.name,
    affiliation: presenter.affiliation,
    countryIndex: presenter.countryIndex,
    displayLanguageIndex: presenter.displayLanguageIndex,
    defaultProgrammingLanguageIndex: presenter.defaultProgrammingLanguageIndex,
    birthYear: presenter.birthYear,
    avatar: presenter.avatar,
    mail: presenter.mail,
    url: presenter.url,
    policyIndex: presenter.policyIndex,
    countryList: presenter.countryList,
    displayLanguageList: presenter.displayLanguageList,
    programmingLanguageList: presenter.programmingLanguageList,
    policyList: presenter.policyList,
    setId: presenter.setId.bind(presenter),
    setPassword: presenter.setPassword.bind(presenter),
    setConfirmPassword: presenter.setConfirmPassword.bind(presenter),
    setName: presenter.setName.bind(presenter),
    setAffiliation: presenter.setAffiliation.bind(presenter),
    setCountryIndex: presenter.setCountryIndex.bind(presenter),
    setDisplayLanguageIndex: presenter.setDisplayLanguageIndex.bind(presenter),
    setDefaultProgrammingLanguageIndex: presenter.setDefaultProgrammingLanguageIndex.bind(presenter),
    setBirthYear: presenter.setBirthYear.bind(presenter),
    setAvatar: presenter.setAvatar.bind(presenter),
    setMail: presenter.setMail.bind(presenter),
    setUrl: presenter.setUrl.bind(presenter),
    setPolicyIndex: presenter.setPolicyIndex.bind(presenter),
    checkPasswordCorrect: presenter.checkPasswordCorrect.bind(presenter),
    uploadAvatar: presenter.uploadAvatar.bind(presenter),
    isAsciiOnly: presenter.isAsciiOnly.bind(presenter),
    isNonEmptyAsciiOnly: presenter.isNonEmptyAsciiOnly.bind(presenter),
    isCorrectPasswordString: presenter.isCorrectPasswordString.bind(presenter),
    checkValues: presenter.checkValues.bind(presenter)
  }
}
